// extracted by mini-css-extract-plugin
export default {"root":"_11Kwr","variant-subscriptions":"_2TeWW","variantSubscriptions":"_2TeWW","variant-adoptables":"_2QScP","variantAdoptables":"_2QScP"};